import type { SearchResultItem } from "@/client"
import { FlashcardResultCard } from "./FlashcardResultCard"
import { QuestionResultCard } from "./QuestionResultCard"

interface SearchResultCardProps {
  item: SearchResultItem
}

export function SearchResultCard({ item }: SearchResultCardProps) {
  switch (item.kind) {
    case "question":
      return <QuestionResultCard item={item} />
    case "flashcard":
      return <FlashcardResultCard item={item} />
    default:
      return null
  }
}
